import Typography from '@mui/material/Typography';
import { useState } from 'react';
import type { SubscriptionProductCF } from '@/types';
import useStyles from './SunrunMembership.styles';

const BILLING_OPTIONS = [
  { id: 'yearly', label: 'Yearly', badge: 'Save 25%' },
  { id: 'monthly', label: 'Monthly' },
];

interface Props {
  membership: SubscriptionProductCF;
}

export default function SunrunMembership({ membership }: Props) {
  const { classes, cx } = useStyles();
  const [selectedId, setSelectedId] = useState(BILLING_OPTIONS[0].id);

  return (
    <div className={classes.root}>
      <div className={classes.priceRow}>
        <Typography variant='h5' component='p'>
          {membership.fields.name}
        </Typography>
        <div className={classes.prices}>
          <Typography
            variant='h4'
            component='p'
            color='semantic.text.accentGreen'
          >
            $79.99/yr
          </Typography>
          <Typography
            component='s'
            color='semantic.text.secondary'
            className={classes.originalPrice}
          >
            $95.88/yr
          </Typography>
        </div>
      </div>
      <div className={classes.toggle}>
        {BILLING_OPTIONS.map(({ id, label, badge }) => (
          <button
            key={id}
            type='button'
            aria-pressed={id === selectedId}
            className={cx(
              classes.toggleOption,
              id === selectedId && classes.toggleOptionSelected
            )}
            onClick={() => setSelectedId(id)}
          >
            <Typography variant='note' component='span' color='inherit'>
              {badge ? `${label} • ` : label}
              {badge && (
                <Typography
                  variant='note'
                  component='span'
                  color='inherit'
                  fontWeight='fontWeightSemibold'
                >
                  {badge}
                </Typography>
              )}
            </Typography>
          </button>
        ))}
      </div>
    </div>
  );
}
